import { render, staticRenderFns } from "./EventDisplay.vue?vue&type=template&id=745914ea&scoped=true&"
import script from "./EventDisplay.vue?vue&type=script&lang=js&"
export * from "./EventDisplay.vue?vue&type=script&lang=js&"
import style0 from "./EventDisplay.vue?vue&type=style&index=0&id=745914ea&prod&scoped=true&lang=scss&"
import style1 from "./EventDisplay.vue?vue&type=style&index=1&id=745914ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745914ea",
  null
  
)

export default component.exports